import React, { useEffect } from "react";
import ReactSVG from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import {
  Text,
  Margin,
  Input,
  Button,
  Loading,
  Alert
} from "~/components/elements";
import * as S from "./styles";
import { schema } from "./validation";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";

import LeftArrow from "~/assets/img/icon/left_arrow.svg";

import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function FormForgot() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const success = useSelector(
    (state) => state.authentication.forgotPass.success
  );
  const sending = useSelector(
    (state) => state.authentication.forgotPass.sending
  );
  const errorMessage = useSelector(
    (state) => state.authentication.forgotPass.errorMessage
  );
  const initialValues = {
    Email: "",
  };

  const location = useLocation();

  // const urlStorage = localStorage.getItem("url");
  // const url = urlStorage !== "null" ? urlStorage : window.location.origin;

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  useEffect(() => {
    dispatch(AuthenticationActions.sendForgotPasswordReset());
    return () => {
      dispatch(AuthenticationActions.sendForgotPasswordReset());
    };
  }, [dispatch]);

  if ( success && errorMessage ) {
    return ( 
      <S.FormHolder>
      <Margin mt={mobile ? 5 : 7} mb={mobile ? 3 : 4}>
        <h1 style={{fontSize: "40px", lineHeight: "44px"}}>
          <strong>
          Pronto, sua  <br className="mobileOnly" />senha foi<br/> atualizada com <br className="mobileOnly" /> sucesso!
          </strong>
        </h1>
      </Margin>
      <Margin mb={4} className="ctn">
        <Text level="2">
            Logo, você receberá um e-mail com essa confirmação.
        </Text>
      </Margin>

      <Margin mb={mobile ? 10 : 11} mt={5}>
          <S.TextHolder className="signup-container">
            <div className="text-container">
              <Text className={"text-black"}>Voltar para o Login</Text>
            </div>
            <S.BtnSignUp
              className="animation-size"
              color={"primary"}
              onClick={() =>
                history.push({
                  pathname: "/login",
                  search: location.search,
                })
              }
            >
              <span style={{marginRight: "8px", fontWeight: "bold"}}>
                <ReactSVG src={LeftArrow} />
              </span>
              <span>
                VOLTAR
              </span>
        </S.BtnSignUp>
      </S.TextHolder>
    </Margin>
    </S.FormHolder>
    )
  }
  
  return (
    <S.FormHolder>
      <Margin mt={mobile ? 5 : 7} mb={mobile ? 3 : 4}>
        <h1 style={{fontSize: "40px", lineHeight: "44px"}}>
          <strong>
            Esqueceu <br className="mobileOnly" />
            sua senha?
          </strong>
        </h1>
      </Margin>
      <Margin mb={4} className="ctn">
        <Text level="2">
          Caso você tenha esquecido sua senha, informe o e-mail utilizado no
          cadastro para receber sua nova senha.
        </Text>
      </Margin>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(
              AuthenticationActions.sendForgotPassword({
                ...values,
                url: url,
                origin,
                Idioma: 0,
                Token: process.env.REACT_APP_PROMO_TOKEN,
              })
            );
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <Margin mb={mobile ? 3 : 4}>
                <Input
                  label="E-mail"
                  placeholder="Digite seu e-mail cadastrado"
                  htmlFor="emailFieldFormForgot"
                  name="Email"
                  value={values.Email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={errors.Email && touched.Email && errors.Email}
                  valid={!errors.Email && touched.Email && !errors.Email}
                  required
                />
              </Margin>
              <S.ButtonHolder>
                <Button
                  className="animation-size"
                  color={!isValid || !dirty || sending ? "disabled" : "primary"}
                  type="submit"
                  disabled={!isValid || !dirty || sending}
                  id="sendButtonFormForgot"
                >
                  {sending ? <Loading button /> : "ENVIAR"}
                </Button>
              </S.ButtonHolder>
              {errorMessage && (
                <Margin mt={3}>
                  <Alert type="error">
                    {errorMessage}
                  </Alert>
                </Margin>
              )}
              <Margin mb={mobile ? 10 : 11} mt={5}>
                <S.TextHolder className="signup-container">
                  <Margin mb={3}>
                    <Text className={"text-black"}>Voltar para o Login</Text>
                  </Margin>
                  <S.BtnSignUp
                    className="animation-size"
                    color={"primary"}
                    onClick={() =>
                      history.push({
                        pathname: "/login",
                        search: location.search,
                      })
                    }
                  >
                    <span style={{marginRight: "8px", fontWeight: "bold"}}>
                      <ReactSVG src={LeftArrow} />
                    </span>
                    <span>
                      VOLTAR
                    </span>
                  </S.BtnSignUp>
                </S.TextHolder>
              </Margin>
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
    </S.FormHolder>
  );
}
